import { useEffect, useState } from 'react';
import { callApi } from 'src/core/callApi';
import { FormData } from 'src/interfaces/iproptypes';

const URL =
  'https://r6up9egux5.execute-api.us-east-2.amazonaws.com/Stage/prod/sendRealtorFromSubmissionEmail';

const useSendApi = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<any>(null);

  const fetchData = async (data: any) => {
    const response = await callApi(
      URL,
      { body: { request_object: data } },
      false,
      false,
      '',
      'POST',
      true
    );
    return response;
  };

  const sendApi = async (formData: FormData) => {
    setIsLoading(true);
    setError(null);
    setData(null);

    try {
      const res: any = await fetchData(formData);

      if (res.error) {
        setError(res.error);
      } else {
        setData(res);
      }
    } catch (error) {
      setError((error as any)?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, error, data, sendApi, setError };
};

export default useSendApi;
